import React from 'react';
import Slider from 'react-slick';
import { FaStar } from "react-icons/fa";
import { PiQuotesFill } from "react-icons/pi";

const HoaTestimonial = () => {
    const starColor = "#FFD700";
    const startColorGray = "#CCC";

    const testimonials = [
        {
            id: 1,
            name: 'William Smith',
            comment: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
            image: require("../../assert/user1.jpg"), // Using placeholder for demo
            stars: [starColor, starColor, starColor, starColor, startColorGray] // 4 yellow stars and 1 gray star
        },
        {
            id: 2,
            name: 'William Smith',
            comment: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
            image: require("../../assert/user2.jpg"), // Using placeholder for demo
            stars: [starColor, starColor, starColor, starColor, starColor] // 5 yellow stars
        },
        {
            id: 3,
            name: 'William Smith',
            comment: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
            image: require("../../assert/user3.jpg"), // Using placeholder for demo
            stars: [starColor, starColor, starColor, starColor, starColor] // 5 yellow stars
        },
    ];

    const slickSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    return (
        <div className="pt-10" id='#hoa-testimonial'>
            <div className="w-[85%] mx-auto">
                {/* Header */}
                <div className="flex justify-center items-center">
                    <h2 className="text-blue-900 text-5xl font-bold leading-normal">
                        Testimonials
                    </h2>
                </div>

                {/* Testimonial Slider */}
                <div className="my-12 flex justify-center">
                    <Slider {...slickSettings} className="w-full [&_.slick-slide]:px-2 [&_.slick-prev:before]:text-blue-900 [&_.slick-next:before]:text-blue-900 [&_.slick-prev:before]:text-2xl [&_.slick-next:before]:text-2xl [&_.slick-prev:hover:before]:opacity-100 [&_.slick-next:hover:before]:opacity-100 [&_.slick-prev:focus:before]:opacity-100 [&_.slick-next:focus:before]:opacity-100">
                        {testimonials.map((testimonial) => (
                            <div key={testimonial.id} className="p-5">
                                {/* User Image */}
                                <div className="flex justify-center items-center pb-4">
                                    <img
                                        src={testimonial.image}
                                        alt={testimonial.name}
                                        className="rounded-full w-24 h-24 object-cover"
                                    />
                                </div>

                                {/* Quote Icon */}
                                <div className="text-4xl flex justify-center items-center pb-4 text-blue-900">
                                    <PiQuotesFill />
                                </div>

                                {/* Review Text */}
                                <div className="flex justify-center items-center pb-5">
                                    <p className="text-base font-normal leading-6 text-center text-blue-900">
                                        {testimonial.comment}
                                    </p>
                                </div>

                                {/* Reviewer Name */}
                                <div className="pb-4">
                                    <p className="font-bold text-center text-blue-900">
                                        {testimonial.name}
                                    </p>
                                </div>

                                {/* Star Rating */}
                                <div className="flex justify-center items-center text-blue-900 gap-2 text-2xl">
                                    {testimonial.stars.map((color, index) => (
                                        <FaStar key={index} style={{ color: color }} />
                                    ))}
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    );
}

export default HoaTestimonial;




// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { PiQuotesFill } from "react-icons/pi";

// const HoaTestimonial = () => {
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [isAutoPlaying, setIsAutoPlaying] = useState(true);

//     const starColor = "#FFD700";
//     const startColorGray = "#CCC";

//     const testimonials = [
//         {
//             id: 1,
//             name: 'William Smith',
//             position: 'CEO & Founder',
//             company: 'TechCorp Solutions',
//             comment: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The exceptional service and attention to detail has transformed our community management experience.',
//             image: require("../../assert/user1.jpg"),
//             stars: [starColor, starColor, starColor, starColor, startColorGray],
//             rating: 4.0
//         },
//         {
//             id: 2,
//             name: 'Sarah Johnson',
//             position: 'Property Manager',
//             company: 'Elite Communities',
//             comment: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. This platform has revolutionized how we handle HOA operations and resident communications.',
//             image: require("../../assert/user2.jpg"),
//             stars: [starColor, starColor, starColor, starColor, starColor],
//             rating: 5.0
//         },
//         {
//             id: 3,
//             name: 'Michael Davis',
//             position: 'Board President',
//             company: 'Harmony Heights HOA',
//             comment: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The automation features have saved us countless hours and improved resident satisfaction.',
//             image: require("../../assert/user3.jpg"),
//             stars: [starColor, starColor, starColor, starColor, starColor],
//             rating: 5.0
//         },
//     ];

//     // Auto-play functionality
//     useEffect(() => {
//         if (!isAutoPlaying) return;

//         const interval = setInterval(() => {
//             setCurrentIndex((prevIndex) =>
//                 prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
//             );
//         }, 5000);

//         return () => clearInterval(interval);
//     }, [isAutoPlaying, testimonials.length]);

//     const handlePrevious = () => {
//         setIsAutoPlaying(false);
//         setCurrentIndex(currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1);
//         setTimeout(() => setIsAutoPlaying(true), 10000); // Resume auto-play after 10 seconds
//     };

//     const handleNext = () => {
//         setIsAutoPlaying(false);
//         setCurrentIndex(currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1);
//         setTimeout(() => setIsAutoPlaying(true), 10000); // Resume auto-play after 10 seconds
//     };

//     const handleDotClick = (index) => {
//         setIsAutoPlaying(false);
//         setCurrentIndex(index);
//         setTimeout(() => setIsAutoPlaying(true), 10000); // Resume auto-play after 10 seconds
//     };

//     // Animation variants
//     const containerVariants = {
//         hidden: { opacity: 0, y: 50 },
//         visible: {
//             opacity: 1,
//             y: 0,
//             transition: {
//                 duration: 0.6,
//                 staggerChildren: 0.2
//             }
//         }
//     };

//     const cardVariants = {
//         enter: {
//             x: 300,
//             opacity: 0,
//             scale: 0.8,
//         },
//         center: {
//             zIndex: 1,
//             x: 0,
//             opacity: 1,
//             scale: 1,
//             transition: {
//                 duration: 0.5,
//                 ease: "easeOut"
//             }
//         },
//         exit: {
//             zIndex: 0,
//             x: -300,
//             opacity: 0,
//             scale: 0.8,
//             transition: {
//                 duration: 0.5,
//                 ease: "easeIn"
//             }
//         }
//     };

//     const buttonVariants = {
//         hover: {
//             scale: 1.1,
//             boxShadow: "0 10px 25px rgba(37, 46, 157, 0.3)",
//             transition: { duration: 0.2 }
//         },
//         tap: {
//             scale: 0.95,
//             transition: { duration: 0.1 }
//         }
//     };

//     const quoteVariants = {
//         hidden: { opacity: 0, scale: 0 },
//         visible: {
//             opacity: 1,
//             scale: 1,
//             transition: {
//                 duration: 0.4,
//                 delay: 0.3,
//                 ease: "easeOut"
//             }
//         }
//     };

//     const currentTestimonial = testimonials[currentIndex];

//     return (
//         <div className="bg-[#ebf4ff] py-20 min-h-screen relative overflow-hidden" id='hoa-testimonial'>
//             {/* Background Elements */}
//             <div className="absolute inset-0 overflow-hidden">
//                 <div className="absolute top-20 left-10 w-72 h-72 bg-[#60a5fa] rounded-full opacity-10 blur-3xl"></div>
//                 <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#252e9d] rounded-full opacity-10 blur-3xl"></div>
//                 <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-r from-[#252e9d] to-[#60a5fa] rounded-full opacity-5 blur-3xl"></div>
//             </div>

//             <motion.div
//                 className="w-[90%] max-w-7xl mx-auto relative z-10"
//                 variants={containerVariants}
//                 initial="hidden"
//                 animate="visible"
//             >
//                 {/* Header */}
//                 <motion.div
//                     className="text-center mb-16"
//                     initial={{ opacity: 0, y: -30 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.6 }}
//                 >
//                     <motion.h2
//                         className="text-[#252e9d] text-6xl font-bold leading-tight mb-4 sm:text-4xl md:text-5xl"
//                         initial={{ opacity: 0, scale: 0.8 }}
//                         animate={{ opacity: 1, scale: 1 }}
//                         transition={{ duration: 0.6, delay: 0.2 }}
//                     >
//                         What Our Clients Say
//                     </motion.h2>
//                     <motion.p
//                         className="text-slate-500 text-lg font-medium"
//                         initial={{ opacity: 0 }}
//                         animate={{ opacity: 1 }}
//                         transition={{ duration: 0.6, delay: 0.4 }}
//                     >
//                         Real experiences from real community managers
//                     </motion.p>
//                 </motion.div>

//                 {/* Main Testimonial Card */}
//                 <div className="relative mb-12">
//                     <AnimatePresence mode="wait">
//                         <motion.div
//                             key={currentIndex}
//                             variants={cardVariants}
//                             initial="enter"
//                             animate="center"
//                             exit="exit"
//                             className="w-full max-w-5xl mx-auto"
//                         >
//                             {/* Glassomorphic Container */}
//                             <div className="relative backdrop-blur-xl bg-[#fefeff]/40 border border-white/30 rounded-3xl p-8 md:p-12 shadow-2xl overflow-hidden">
//                                 {/* Glass reflection effect */}
//                                 <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-3xl"></div>
//                                 <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/50 to-transparent"></div>

//                                 {/* Content Layout */}
//                                 <div className="relative z-10 grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
//                                     {/* Left Side - User Image */}
//                                     <div className="lg:col-span-2 flex flex-col items-center lg:items-start">
//                                         <motion.div
//                                             className="relative mb-6"
//                                             initial={{ opacity: 0, scale: 0.5 }}
//                                             animate={{ opacity: 1, scale: 1 }}
//                                             transition={{ duration: 0.5, delay: 0.2 }}
//                                         >
//                                             {/* Image with glowing border */}
//                                             <div className="relative">
//                                                 <div className="absolute inset-0 bg-gradient-to-r from-[#252e9d] to-[#60a5fa] rounded-full p-1">
//                                                     <div className="w-40 h-40 bg-[#ebf4ff] rounded-full"></div>
//                                                 </div>
//                                                 <img
//                                                     src={currentTestimonial.image}
//                                                     alt={currentTestimonial.name}
//                                                     className="relative w-40 h-40 rounded-full object-cover border-4 border-white shadow-xl"
//                                                 />
//                                                 {/* Floating elements */}
//                                                 <motion.div
//                                                     className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-r from-[#252e9d] to-[#60a5fa] rounded-full"
//                                                     animate={{
//                                                         scale: [1, 1.2, 1],
//                                                         opacity: [0.7, 1, 0.7]
//                                                     }}
//                                                     transition={{ duration: 2, repeat: Infinity }}
//                                                 />
//                                                 <motion.div
//                                                     className="absolute -bottom-1 -left-1 w-4 h-4 bg-[#60a5fa] rounded-full"
//                                                     animate={{
//                                                         scale: [1, 1.3, 1],
//                                                         opacity: [0.5, 1, 0.5]
//                                                     }}
//                                                     transition={{ duration: 2.5, repeat: Infinity, delay: 0.5 }}
//                                                 />
//                                             </div>
//                                         </motion.div>

//                                         {/* User Info */}
//                                         <motion.div
//                                             className="text-center lg:text-left"
//                                             initial={{ opacity: 0, y: 20 }}
//                                             animate={{ opacity: 1, y: 0 }}
//                                             transition={{ duration: 0.5, delay: 0.4 }}
//                                         >
//                                             <h3 className="text-2xl font-bold text-[#252e9d] mb-2">
//                                                 {currentTestimonial.name}
//                                             </h3>
//                                             <p className="text-[#60a5fa] font-semibold mb-1">
//                                                 {currentTestimonial.position}
//                                             </p>
//                                             <p className="text-slate-500 font-medium text-sm">
//                                                 {currentTestimonial.company}
//                                             </p>
//                                         </motion.div>
//                                     </div>

//                                     {/* Right Side - Comment and Details */}
//                                     <div className="lg:col-span-3 flex flex-col justify-center">
//                                         {/* Quote Icon */}
//                                         <motion.div
//                                             className="flex justify-center lg:justify-start mb-6"
//                                             variants={quoteVariants}
//                                             initial="hidden"
//                                             animate="visible"
//                                         >
//                                             <div className="relative">
//                                                 <PiQuotesFill className="text-6xl text-[#252e9d] opacity-20" />
//                                                 <PiQuotesFill className="absolute top-0 left-0 text-4xl text-[#252e9d]" />
//                                             </div>
//                                         </motion.div>

//                                         {/* Comment */}
//                                         <motion.div
//                                             className="mb-8"
//                                             initial={{ opacity: 0, y: 30 }}
//                                             animate={{ opacity: 1, y: 0 }}
//                                             transition={{ duration: 0.5, delay: 0.3 }}
//                                         >
//                                             <p className="text-lg leading-relaxed text-[#252e9d] font-medium text-center lg:text-left">
//                                                 "{currentTestimonial.comment}"
//                                             </p>
//                                         </motion.div>

//                                         {/* Rating */}
//                                         <motion.div
//                                             className="flex flex-col items-center lg:items-start gap-4"
//                                             initial={{ opacity: 0, y: 20 }}
//                                             animate={{ opacity: 1, y: 0 }}
//                                             transition={{ duration: 0.5, delay: 0.5 }}
//                                         >
//                                             <div className="flex items-center gap-3">
//                                                 <div className="flex gap-1">
//                                                     {currentTestimonial.stars.map((color, index) => (
//                                                         <motion.div
//                                                             key={index}
//                                                             initial={{ opacity: 0, scale: 0 }}
//                                                             animate={{ opacity: 1, scale: 1 }}
//                                                             transition={{ duration: 0.3, delay: 0.6 + (index * 0.1) }}
//                                                         >
//                                                             <FaStar
//                                                                 className="text-xl"
//                                                                 style={{ color: color }}
//                                                             />
//                                                         </motion.div>
//                                                     ))}
//                                                 </div>
//                                                 <span className="text-[#252e9d] font-bold text-lg">
//                                                     {currentTestimonial.rating}/5.0
//                                                 </span>
//                                             </div>
//                                             <div className="flex items-center gap-2 text-sm text-slate-500">
//                                                 <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
//                                                 <span>Verified Review</span>
//                                             </div>
//                                         </motion.div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </motion.div>
//                     </AnimatePresence>

//                     {/* Navigation Buttons */}
//                     <motion.button
//                         className="absolute left-4 top-1/2 transform -translate-y-1/2 w-14 h-14 bg-[#fefeff] border-2 border-[#252e9d]/20 rounded-full flex items-center justify-center shadow-xl backdrop-blur-sm z-20"
//                         onClick={handlePrevious}
//                         variants={buttonVariants}
//                         whileHover="hover"
//                         whileTap="tap"
//                         initial={{ opacity: 0, x: -50 }}
//                         animate={{ opacity: 1, x: 0 }}
//                         transition={{ duration: 0.5, delay: 0.8 }}
//                     >
//                         <FaChevronLeft className="text-[#252e9d] text-lg" />
//                     </motion.button>

//                     <motion.button
//                         className="absolute right-4 top-1/2 transform -translate-y-1/2 w-14 h-14 bg-[#fefeff] border-2 border-[#252e9d]/20 rounded-full flex items-center justify-center shadow-xl backdrop-blur-sm z-20"
//                         onClick={handleNext}
//                         variants={buttonVariants}
//                         whileHover="hover"
//                         whileTap="tap"
//                         initial={{ opacity: 0, x: 50 }}
//                         animate={{ opacity: 1, x: 0 }}
//                         transition={{ duration: 0.5, delay: 0.8 }}
//                     >
//                         <FaChevronRight className="text-[#252e9d] text-lg" />
//                     </motion.button>
//                 </div>

//                 {/* Progress Dots */}
//                 <motion.div
//                     className="flex justify-center items-center gap-3"
//                     initial={{ opacity: 0, y: 30 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.5, delay: 1 }}
//                 >
//                     {testimonials.map((_, index) => (
//                         <motion.button
//                             key={index}
//                             className={`relative w-3 h-3 rounded-full transition-all duration-300 ${index === currentIndex
//                                 ? 'bg-[#252e9d] scale-125'
//                                 : 'bg-[#252e9d]/30 hover:bg-[#252e9d]/50'
//                                 }`}
//                             onClick={() => handleDotClick(index)}
//                             whileHover={{ scale: 1.2 }}
//                             whileTap={{ scale: 0.9 }}
//                         >
//                             {index === currentIndex && (
//                                 <motion.div
//                                     className="absolute inset-0 bg-[#252e9d] rounded-full"
//                                     layoutId="activeDot"
//                                     transition={{ duration: 0.3 }}
//                                 />
//                             )}
//                             {/* Progress ring for auto-play */}
//                             {index === currentIndex && isAutoPlaying && (
//                                 <motion.div
//                                     className="absolute -inset-1 border-2 border-[#60a5fa] rounded-full"
//                                     initial={{ opacity: 0, scale: 0.8 }}
//                                     animate={{
//                                         opacity: [0, 1, 0],
//                                         scale: [0.8, 1.2, 0.8]
//                                     }}
//                                     transition={{
//                                         duration: 5,
//                                         repeat: Infinity,
//                                         ease: "linear"
//                                     }}
//                                 />
//                             )}
//                         </motion.button>
//                     ))}
//                 </motion.div>

//                 {/* Stats Section */}
//                 <motion.div
//                     className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16"
//                     initial={{ opacity: 0, y: 50 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.6, delay: 1.2 }}
//                 >
//                     {[
//                         { number: '500+', label: 'Happy Communities' },
//                         { number: '98%', label: 'Satisfaction Rate' },
//                         { number: '24/7', label: 'Support Available' },
//                         { number: '5★', label: 'Average Rating' }
//                     ].map((stat, index) => (
//                         <motion.div
//                             key={index}
//                             className="text-center backdrop-blur-sm bg-[#fefeff]/30 rounded-2xl p-6 border border-white/20"
//                             whileHover={{
//                                 scale: 1.05,
//                                 boxShadow: "0 10px 25px rgba(37, 46, 157, 0.1)"
//                             }}
//                             transition={{ duration: 0.2 }}
//                         >
//                             <div className="text-3xl font-bold text-[#252e9d] mb-2">
//                                 {stat.number}
//                             </div>
//                             <div className="text-slate-500 font-medium">
//                                 {stat.label}
//                             </div>
//                         </motion.div>
//                     ))}
//                 </motion.div>
//             </motion.div>
//         </div >
//     );
// }

// export default HoaTestimonial;


